export const contractorStoreKey = 'contractor';
